export default "__VITE_ASSET__94MhM3iG__"